/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETAWARDSBYUSRID= createAsyncThunk(
  "getAwardsByUserId/getAwardsByUserId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAwardsByUserIdSlice = createSlice({
  name: "getAwardsByUserIdSlice",
  initialState: {
    getAwardsByUserId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAwardsByUserId: (state) => {
        state.getAwardsByUserId.loading = false
        state.getAwardsByUserId.error = false
        state.getAwardsByUserId.data = []
        state.getAwardsByUserId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETAWARDSBYUSRID.fulfilled, (state, action) => {
      state.getAwardsByUserId = {
        ...state.getAwardsByUserId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAWARDSBYUSRID.pending, (state, action) => {
      state.getAwardsByUserId = {
        ...state.getAwardsByUserId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETAWARDSBYUSRID.rejected, (state, action) => {
      state.getAwardsByUserId = {
        ...state.getAwardsByUserId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAwardsByUserIdAction = {
    GETAWARDSBYUSRID,
};

export { getAwardsByUserIdAction };
export default getAwardsByUserIdSlice.reducer;
export const {setInitialStateOfgetAwardsByUserId} = getAwardsByUserIdSlice.actions